import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import CreateGoalOverviewTab from '../CreateGoalOverviewTab.tsx';
import CreateGoalKeyResults from '../CreateGoalKeyResultsTab';
import { GoalState } from '../../helpers/goals.types';

interface CreateGoalTabsProps {
  isEdit?: boolean;
  setIsEdit?: (isEdit: boolean) => void;
  goalState?: GoalState;
  setGoalState?: (goalState: GoalState) => void;
  goalStateLoading?: boolean;
}

export const CreateGoalTabs = ({
  isEdit,
  setIsEdit,
  goalState,
  setGoalState,
  goalStateLoading,
}: CreateGoalTabsProps) => {
  const [goalId, setGoalId] = useState('');
  const [goalScope, setGoalScope] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);

  const handleNextTab = () => {
    setTabIndex((prev) => prev + 1);
  };

  useEffect(() => {
    if (isEdit) {
      if (goalState?.id) {
        setGoalId(goalState?.id);
        setGoalScope(goalState?.scope);
      }
    }
    setIsLoading(false);
  }, [goalState, isEdit]);

  if (isLoading && isEdit) {
    return null;
  }

  const tabPanels = [
    {
      component: (
        <CreateGoalOverviewTab
          setGoalId={setGoalId}
          setGoalScope={setGoalScope}
          onNext={handleNextTab}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          goalState={goalState}
          setGoalState={setGoalState}
          goalStateLoading={goalStateLoading}
        />
      ),
      label: 'Overview',
    },
    {
      component: (
        <CreateGoalKeyResults
          goalId={goalId}
          goalScope={goalScope}
          isEdit={isEdit}
          keyResultState={goalState?.keyResults}
        />
      ),
      label: 'Key Results',
    },
  ];

  return (
    <Tabs index={tabIndex} onChange={(index) => setTabIndex(index)}>
      <TabList>
        {tabPanels.map((tab, index) => (
          <Tab
            key={index}
            fontSize={'sm'}
            fontWeight="medium"
            color="text.secondary"
            _selected={{
              color: 'primary',
              borderBottom: '2px solid',
              borderColor: 'primary',
            }}
            isDisabled={tab.label === 'Key Results' && !goalId}
          >
            {tab.label}
          </Tab>
        ))}
      </TabList>

      <TabPanels>
        {tabPanels.map((tab, index) => (
          <TabPanel key={index}>{tab.component}</TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};

export default CreateGoalTabs;
